import { produce } from "immer";
import { SET_IS_FIRST_SHOW_INTRO, SHOW_WATCH_MORE_VIDEOS_LATER_TOOLTIP } from "./tutorialsConstants";

const initialState = {
    isFirstShowIntro: false,
    isShowWatchMoreVideosLaterTooltip: false,
}

const tutorialsReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SHOW_WATCH_MORE_VIDEOS_LATER_TOOLTIP:
                draft.isShowWatchMoreVideosLaterTooltip = action.payload;
                break;

            case SET_IS_FIRST_SHOW_INTRO:
                draft.isFirstShowIntro = action.payload;
                break;

            default:
                return state;
        }
    })

export default tutorialsReducer;